import * as urlUtil from '@tencent/vft-common/url';
import Version from '@tencent/vft-atom/lib/Version';
import atom from '@tencent/vft-atom';
import { getPlayright, getNewsCMSID } from './videoPlayright';

/**
 * 在 h5 或 小程序 或 native 中打开
 * @return {String} h5/ weapp/ native
 */
const openType = function () {
  const env = window.magicApp?.env;
  const version = env?.appVersion;

  const vObj = new Version(version);

  if (!vObj.compare('6.4.9')) return 'h5';

  if (!vObj.compare('6.5.20')) return 'weapp';

  return 'native';
};

const qqnewsHandler = async function ({ cid, vid }) {
  if (!cid && !vid) return false;

  const { isQQNews } = window.magicApp?.env;

  if (!isQQNews) return false;

  const type = openType();
  if (type === 'h5') return false;

  if (type === 'weapp') {
    const path = urlUtil.buildUrl('pages/play/index.html', { cid, vid });

    atom.openUrl(`qqnews://article_9528?act=wxa&wxaId=wxa75efa648b60994b&entry=${encodeURIComponent(path)}`);
    return true;
  }

  if (type === 'native') {
    const data = await getPlayright({ cid, vid });
    if (!vid) {
      // eslint-disable-next-line
      vid = data.vid;
    }

    // 20 表示支持新闻客户端
    const { playright } = data.fields;
    if (!playright || !playright.includes('20')) return false;

    const cmsid = await getNewsCMSID({ cid, vid });

    if (!cmsid) return false;

    atom.openUrl(`qqnews://article_9527?nm=NEWSJUMP_229&jumpinfo={"news_id":"${cmsid.news_id}","cur_vid":"${cmsid.cur_vid || ''}","ref_source":"40012"}`);
    return true;
  }

  return false;
};

export default qqnewsHandler;
